import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { AuthAppService } from 'avn/modules/services/auth-app/auth-app.service';
import { SsrReplaceService } from 'avn/modules/services/ssr-replace.service';

@Injectable({
  providedIn: 'root'
})
export class Auth0UiService {
  public constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly ssr: SsrReplaceService,
    private readonly authApp: AuthAppService
  ) {}

  private static readonly key_frontend = 'WORKCOVER_JWT_KEY';
  private static readonly key_backend = 'WORKCOVER_JWT_KEY_BACKEND';

  public loginCheck(path?: string): void {
    if (this.authApp.clientType() === 'frontend') {
      this.auth.idTokenClaims$.subscribe((id: any) => {
        if (id?.__raw) {
          console.info('', id);
          this.setAuth(id.__raw);
          this.setworkcoverLoggedUser(id);

          const url_redirect_mode = localStorage.getItem('url_redirect_mode');
          if (url_redirect_mode) {
            localStorage.removeItem('url_redirect_mode');
            this.router.navigate([url_redirect_mode]);
          }

          if (path) {
            localStorage.setItem('current_path', path);
          }
        }
      });

      this.auth.isAuthenticated$.subscribe((au: any) => {
        if (!au) {
          this.auth.loginWithRedirect();
        }
      });
    }
  }

  public signOut(): void {
    localStorage.clear();
    this.auth.logout({ logoutParams: { returnTo: this.ssr.getLocation().origin + '/' } });
  }

  public setAuth(token: string): void {
    localStorage.setItem('WORKCOVER_JWT_KEY', token);
  }

  public setworkcoverLoggedUser(user: any): void {
    localStorage.setItem('ClientType', 'frontend');
    localStorage.setItem('workcoverLoggedUser', JSON.stringify(user));
    localStorage.setItem('workCoverLastLogin', new Date().toString());
  }
}
